import { useEffect, useState } from "react";

const SESSION_STORAGE_KEY = "showSubscriptionActiveOverlay";

/**
 * Hook to manage subscription active overlay state
 *
 * Checks sessionStorage for "showSubscriptionActiveOverlay" flag set by PlanSelectionModal
 * after successful subscription creation.
 *
 * @returns Object containing showOverlay state and handleClose function
 */
export const useSubscriptionActiveOverlay = () => {
  const [showOverlay, setShowOverlay] = useState(false);

  useEffect(() => {
    // Check if subscription was just activated
    const shouldShow = sessionStorage.getItem(SESSION_STORAGE_KEY) === "true";

    if (shouldShow) {
      // Clear the flag immediately to prevent showing on subsequent refreshes
      sessionStorage.removeItem(SESSION_STORAGE_KEY);
      setShowOverlay(true);
    }
  }, []);

  const handleClose = () => {
    setShowOverlay(false);
  };

  return { showOverlay, handleClose };
};
